var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewBostonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.057,
    height: 59.187,
    viewBox: "0 0 48.057 59.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2048",
    "data-name": "Rectangle 2048",
    width: 48.057,
    height: 59.187,
    fill: "#084cbc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3528",
    "data-name": "Group 3528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M56.507,90.391V88.7L44.025,93.239V89.744L56.507,85.2V83.507L44.025,88.05,31.568,83.516V85.21l1.916.7v3.486l-1.916-.7v1.7l12.457,4.534Z",
    transform: "translate(-28.687 -75.886)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M120.548,0l-.925,6.218-3.86,1.4,4.785,1.742,4.785-1.742-3.86-1.4Z",
    transform: "translate(-105.198)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M0,454.3l15.338,5.583V446.523L0,440.94Z",
    transform: "translate(-0.001 -400.696)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M0,200.986l15.338,5.583V186.853l15.338-5.583v-1.7l-15.338,5.583L0,179.573Z",
    transform: "translate(0 -163.184)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M344.672,238.458l-2.638.966v-4.707l2.3-.837v-1.911l-2.3.837v-4.8l2.515-.915V225.1l-4.618,1.681v15.386l4.741-1.726Z",
    transform: "translate(-308.906 -204.557)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M295.387,267.33l2.148-.782V251.162l-2.148.782Z",
    transform: "translate(-268.427 -228.239)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M211.558,266.569l-1.087,11.778-1.416-10.867-2.073.755,2.038,14.645,2.766-1.006,1.728-16.016Z",
    transform: "translate(-188.09 -241.593)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M410.073,176.347l-1.146,11.97-1.6-10.97-1.863.678-1.305,12.016L402.6,179.065l-1.958.713,2.171,14.6,2.5-.911,1.3-10.22,1.181,9.316,2.528-.92,1.8-16.043Z",
    transform: "translate(-364.079 -159.57)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M224.779,475.667a.7.7,0,0,0-.421-.163,1.771,1.771,0,0,0,.6-1.28.976.976,0,0,0-.39-.89,1.181,1.181,0,0,0-1.036-.027l-1.656.6v5.12s.921-.337,1.771-.645a2.106,2.106,0,0,0,1.438-1.93.982.982,0,0,0-.3-.789m-1.964-1.19.595-.215a.524.524,0,0,1,.447-.005.408.408,0,0,1,.147.37.884.884,0,0,1-.625.828l-.564.2Zm.64,3.091-.64.231v-1.253l.689-.249a.523.523,0,0,1,.45,0,.448.448,0,0,1,.164.407.921.921,0,0,1-.663.862",
    transform: "translate(-201.621 -430.016)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M477.2,377.22l-2.026-2.778-.96.349v5.119l.952-.346v-3.593l2.085,2.835.912-.332v-5.12l-.963.35Z",
    transform: "translate(-430.931 -339.279)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M417.12,399.875a1.819,1.819,0,0,0-1.6-.089,3.528,3.528,0,0,0-1.648,1.3,3.834,3.834,0,0,0-.722,2.2,1.94,1.94,0,0,0,.77,1.746,1.552,1.552,0,0,0,.837.229,2.266,2.266,0,0,0,.758-.14,3.542,3.542,0,0,0,1.653-1.3,3.817,3.817,0,0,0,.723-2.2,1.947,1.947,0,0,0-.771-1.752m-1.615,4.212a1.023,1.023,0,0,1-.9-.045,1.21,1.21,0,0,1-.449-1.1,2.274,2.274,0,0,1,1.4-2.152,1.319,1.319,0,0,1,.441-.082.862.862,0,0,1,.465.126,1.209,1.209,0,0,1,.448,1.1,2.278,2.278,0,0,1-1.405,2.154",
    transform: "translate(-375.442 -363.17)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M325.536,437.376a1.215,1.215,0,0,0-.94-.192l-.632.09a.42.42,0,0,1-.327-.059.363.363,0,0,1-.116-.3,1.02,1.02,0,0,1,.689-.861.643.643,0,0,1,.514-.007.514.514,0,0,1,.245.361l.881-.529a1.08,1.08,0,0,0-.523-.781,1.428,1.428,0,0,0-1.146.02,2.539,2.539,0,0,0-1.615,2.179,1.057,1.057,0,0,0,.345.872,1.145,1.145,0,0,0,.881.188l.632-.083a.5.5,0,0,1,.38.071.358.358,0,0,1,.12.3.968.968,0,0,1-.714.849.832.832,0,0,1-.642,0,.747.747,0,0,1-.331-.539l-.858.515a1.2,1.2,0,0,0,.562.965,1.151,1.151,0,0,0,.579.144,2.125,2.125,0,0,0,.706-.138,2.5,2.5,0,0,0,1.673-2.178,1.066,1.066,0,0,0-.362-.883",
    transform: "translate(-292.956 -395.288)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M367.024,415.182l1.426-.516v4.181l.942-.343,0-4.178,1.457-.527v-.946l-3.827,1.393Z",
    transform: "translate(-333.526 -375.173)",
    fill: "#084cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M268.075,453.84a1.819,1.819,0,0,0-1.6-.089,3.528,3.528,0,0,0-1.648,1.3,3.835,3.835,0,0,0-.722,2.2,1.941,1.941,0,0,0,.77,1.746,1.552,1.552,0,0,0,.837.229,2.265,2.265,0,0,0,.758-.139,3.542,3.542,0,0,0,1.653-1.3,3.818,3.818,0,0,0,.723-2.2,1.947,1.947,0,0,0-.771-1.752m-1.615,4.212a1.022,1.022,0,0,1-.9-.045,1.211,1.211,0,0,1-.449-1.1,2.273,2.273,0,0,1,1.4-2.152,1.321,1.321,0,0,1,.441-.082.862.862,0,0,1,.465.126,1.209,1.209,0,0,1,.448,1.1,2.278,2.278,0,0,1-1.4,2.154",
    transform: "translate(-240 -412.21)",
    fill: "#084cbc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBostonLogo);
export default __webpack_public_path__ + "static/media/view_boston_logo.76ef0ac7c0535d7a08714c8d3b2f3355.svg";
export { ForwardRef as ReactComponent };